<div style="padding: 0px;">

    <div>
        <div class="col-md-12 col-lg-12 col-12" style="padding: 15px; padding-bottom: 0px;">
            <div class="col-md-9 col-lg-9 col-9" style="padding: 0px; display: inline-block;">
                <!-- <span class="mobView" style="font-size: 22px; margin-right: 10px; display: inline-block;" (click)="back()"><i class="fa fa-chevron-left"></i></span> -->
                <h4 style="padding-right: 15px; display: inline-block;">{{ typeID == 1 ? 'Copy Stages' : 'Copy BOM' }}</h4>
            </div>
            <div class="col-md-3 col-lg-3 col-3" style="padding: 0px; display: inline-block; text-align: right;">
                <i class="closeMdl zmdi zmdi-close webView" style="position: relative; bottom: 10px; margin-top: 0px;" (click)="closeModal()"></i>
            </div>
    
        </div>
        <div style="padding-left: 15px; padding-right: 15px;">
            <div class="col-md-12 col-lg-12 col-12" style="display: inline-block; width: 100%; margin-top: 10px; padding: 0px;">
                <div class="input-icons search">
                    <span class="fa fa-search" style="color: #999; font-size: 13px; margin-left: 0px; margin-top: -2px;"></span>
                    <input class="form-control brdrRadius3 searchBar" [(ngModel)]="search" placeholder="Search" style="padding-left: 35px !important; padding: 16px; box-shadow: none; float: left; border: 1px solid #BCC2C9 !important;" type="text">
                </div>
            </div>
        </div>
    </div>
    
    <div class="modal-body" style="margin-top: 5px; margin-bottom: 70px; padding: 0px; overflow-y: auto; min-height: 40vh; max-height: 60vh;">       
        <div class="col-md-12 col-lg-12 col-12" style="padding: 0px;">
            <div class="col-md-12 col-lg-12 col-12" *ngFor="let a of Items | filter:'ItemName,CategoryName,SC':search" (click)="selectItem(a)" style="background: #FFF; padding: 10px 15px 10px 15px; border-top: 10px solid #F8F8F8; font-size: 14px; cursor: pointer;">
                <!-- Name --> 
                
                <div class="col-md-8 col-lg-8 col-8" style="font-weight: bold; display: inline-block; padding: 0px; cursor: pointer !important;">
                    <input type="checkbox" id="item" name="item" [(ngModel)]="a.isSelected" style="vertical-align: middle; margin-right: 5px; position: relative; top: 0px; cursor: pointer !important;width: 15px;height: 15px;"> 
                    <span style="vertical-align: middle; color: #444444; margin-left: 5px; font-size: 13px;">{{a.ItemName}}</span>
                </div>
    
                <!-- qty -->
                <div class="col-md-4 col-lg-4 col-4" style="display: inline-block; text-align: right; padding: 0px;">
                    <div class="greenBadge-wb" style="padding: 3px 10px !important; font-size: 12px;">
                        {{a.CurrQty}} {{a.SKU}}
                    </div>
                </div> 
    
                <!-- code -->
                <div class="col-md-12 col-lg-12 col-12 ml7" style="display: inline-block; text-align: left; padding: 0px; color: #777777;">
                    <div class="darkBlueBadge-wb" style="margin: 10px 5px 10px 0px; font-size: 12px; padding: 3px 10px;" title="Item Code">
                        # {{a.ItemCode}}
                    </div>
                    <div class="darkBlueBadge-wb" *ngIf="a.CategoryName" style="margin-right: 5px; margin-top: 5px;font-size: 13px;">
                        {{a.CategoryName}}
                    </div>
                    <div class="darkBlueBadge-wb" *ngIf="a.SubCategoryName" style="margin-right: 5px; margin-top: 5px;font-size: 13px;">
                        {{a.SubCategoryName}}
                    </div>
                </div> 
            </div>
        </div>
    </div>
    <div class="wid500 bottom" style="position: fixed; text-align: center;">
        <div class="darkBlueButton brdrRadius3" (click)="select()" style="padding: 0px 15px !important; line-height: 30px; font-size: 14px;"> <i class="fa fa-check" aria-hidden="true"></i> Select </div>
    </div>
</div>

<!-- Store Selection Modal -->
<ng-template #storeSelect let-modal>
    <app-select-store></app-select-store>
</ng-template>



